// Warnung statt Sperre (Entscheidung David 27.10.2026): Für ein gewähltes Zusatzziel stehen im eingelegten Stand keine
// eigenen Werte. Der Antrag bleibt möglich; der Workflow verwendet dann die Werte der Basisstufe. Die Daten liefert das
// Board (cells[quelle].nextValuesMissing), die Antwort des Antrags trägt dieselbe Warnung STAGE_TARGET_VALUES_MISSING.
import { useTranslation } from "react-i18next";
import { Alert, Stack, Typography } from "@mui/material";
import { stageLabel } from "../../utils/stages";
import { valuesMissingTargets } from "../boardAdapter";

/** Name der Basisstufe: die erste konfigurierte Stufe nach DEV (deren Werte als Default gelten). */
export function baseStageLabel(board) {
  const base = (board?.stages || []).find(stage => stage.configured === true && stage.key !== "dev");
  return base ? base.label || stageLabel(base.key) : stageLabel("qas");
}

/** Anzeigename eines Ziels der Stufe aus dem Board, sonst die Ziel-ID. */
export function targetNameOf(board, stage, targetId) {
  const row = (board?.stages || []).find(item => item.key === stage);
  const target = (row?.allTargets || row?.targets || []).find(item => item.targetId === targetId);
  return target?.instanceName || target?.environment || targetId;
}

export default function TargetValuesWarning({ board, sourceStage, targetStage, packageIds, targetIds }) {
  const { t } = useTranslation("freigabe");
  if (!Array.isArray(targetIds) || !targetIds.length) return null;
  const missing = valuesMissingTargets(board, { sourceStage, targetStage, packageIds, targetIds });
  if (!missing.length) return null;
  const stage = baseStageLabel(board);
  return <Alert severity="warning" variant="outlined" role="status">
    <Stack spacing={0.5}>
      {missing.map(entry => <Typography key={entry.targetId} component="span" variant="body2" sx={{ display: "block", overflowWrap: "anywhere" }}>
        {t("stageBranches.targets.valuesMissing", { name: targetNameOf(board, targetStage, entry.targetId), stage })}
      </Typography>)}
    </Stack>
  </Alert>;
}
